<app-layout />

@if (loadingService.isLoading()) {
  <div class="loading-overlay">
    <mat-spinner diameter="60" />
    @if (loadingService.message()) {
      <p class="loading-message">
        {{ loadingService.message() }}
      </p>
    }
  </div>
}

@if (messageService.isVisible()) {
  <div class="message-overlay" [ngClass]="messageService.type()">
    <p>{{ messageService.message() }}</p>
  </div>
}
